export interface Country {
  id: string;
  name: string;
  code: string;
}

export interface CountriesResponse {
  countries: Country[];
}

export function getCountryIcon(_countryCode: string): React.ReactNode {
  return null;
}


export function getCountryIconUrl(_countryCode: string): string {
  return `/flags/${_countryCode.trim().toUpperCase()}.svg`;
}


